<template>
  <v-menu
    :close-on-content-click="false"
    offset-y
    left
    transition="slide-y-transition"
    v-model="menuOpen"
    @input="onMenuToggle"
  >
    <template #activator="{ on }">
      <v-btn
        text
        :icon="$vuetify.breakpoint.smAndDown"
        v-on="on"
        :class="{'btn-40': $vuetify.breakpoint.smAndDown}"
      >
        <span
          class="text-truncate d-md-inline d-sm-none"
          style="max-width: 200px"
          v-show="$vuetify.breakpoint.mdAndUp"
          :class="[$vuetify.rtl ? 'mr-1' : 'ml-1']"
          v-if="selectedOutlet"
        >{{ selectedOutlet.name }}</span>
        <span
          class="text-truncate d-md-inline d-sm-none"
          style="max-width: 200px; color: #999; font-style: italic;"
          v-show="$vuetify.breakpoint.mdAndUp"
          :class="[$vuetify.rtl ? 'mr-1' : 'ml-1']"
          v-else-if="isLoadingOutlets"
        >Loading...</span>
        <span
          class="text-truncate d-md-inline d-sm-none"
          style="max-width: 200px"
          v-show="$vuetify.breakpoint.mdAndUp"
          :class="[$vuetify.rtl ? 'mr-1' : 'ml-1']"
          v-else
        >No Outlet</span>
        <v-icon
          class="d-sm-inline d-md-none"
        >
          mdi-cash-register
        </v-icon>
        <v-icon
          right
          class="d-md-inline d-sm-none"
          v-show="$vuetify.breakpoint.mdAndUp"
        >
          mdi-chevron-down
        </v-icon>
      </v-btn>
    </template>
    <v-card
      max-height="500px"
      width="400px"
      style="
        background: white;
        padding: 10px 0;
        border: solid 1px #d6d0d0 !important;
      "
    >
      <v-text-field
        v-if="showSearchOutlet"
        v-model="searchOutletKeyword"
        placeholder="Filter Outlet..."
        flat
        hide-details
        rounded
        prepend-inner-icon="mdi-magnify"
        class="mx-1 mb-1"
        ref="outletSearchField"
      />
      <v-list
        dense
        nav
      >
        <v-list-item-group
          v-model="activeList"
          color="primary"
        >
          <v-list-item
            v-for="outlet in filteredOutlets"
            :key="outlet.id"
            @click="SetOutlet(outlet)"
          >
            <v-list-item-title>
              <v-icon
                v-if="outlet.default_outlet"
                style="color: darkorange; font-size: small; top: -2px;"
              >
                mdi-star
              </v-icon>
              {{ outlet.name }}
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import qs from "query-string";
import { autoFocusMixin } from "@/mixins/autoFocusMixin";

export default {
  mixins: [autoFocusMixin],
  data() {
    return {
      searchOutletKeyword: "",
      menuOpen: false
    };
  },
  props: {
    showLabel: {
      type: Boolean,
      default: true,
    }
  },
  mounted() {
    // this.setPageLoading(true);
  },
  computed: {
    ...mapState("app", ["outlets", "outlet", "openToolbarMenu"]),
    isLoadingOutlets() {
      const hotelId = parseInt(this.$route.query.hotelId);
      if (!hotelId) return false;

      // HIERARCHICAL LOADING: Replicate ToolbarHotels' isLoadingHotel logic
      const selectedChainId = this.$store.state.app.selectedHotelChainId;

      if (selectedChainId !== null) {
        // Find selectedHotel the same way ToolbarHotels does
        const hotels = this.$store.state.app.hotels || [];
        let selectedHotel = {};

        if (hotels && hotels.length > 0) {
          const hotelIdFromQuery = this.$route.query.hotelId;
          // Find default Hotel
          selectedHotel = hotels.find((i) => i.default_hotel);
          if (selectedHotel == null || typeof selectedHotel == "undefined"){
            selectedHotel = hotels[0];
          }
          if (hotelIdFromQuery) {
            selectedHotel = hotels.find((i) => i.id == hotelIdFromQuery);
          }
        }

        // Check if hotel is in transition (same check as ToolbarHotels)
        if (selectedHotel && selectedHotel.id) {
          if (selectedHotel.hotel_chain_id !== selectedChainId) {
            // Hotel is loading, so outlet should also show loading
            return true;
          }
        }
      }

      // Check if we have any outlets for this specific hotel
      const hotelsOutlets = this.outlets.filter(o => o.hotel_id === hotelId);

      // If we have a hotel selected but no outlets loaded yet, we're loading
      return hotelsOutlets.length === 0 && this.outlets.length >= 0;
    },
    filteredOutlets() {
      const hotelId = parseInt(this.$route.query.hotelId);
      const outlets = this.outlets
        .filter((o) => {
          return o.hotel_id === hotelId && o?.name
            ?.toLowerCase()
            ?.includes(this.searchOutletKeyword?.toLowerCase());
        }).sort((outletPrev, outletNext) => (outletPrev.sort_order ?? 0) - (outletNext.sort_order ?? 0));

      return outlets || [];
    },
    selectedOutlet() {
      const hotelId = parseInt(this.$route.query.hotelId);
      let outlet = {};
      const outletId = Number(this.$route.query.outletId);
      const filtered = this.outlets.filter(r => r.hotel_id == hotelId);
      if (filtered.length > 0) {
        outlet = filtered.find((i) => i.default_outlet);
        if (outlet == null || typeof outlet == "undefined"){
          outlet = filtered[0];
        }
        if (outletId > 0) {
          outlet = filtered.find((i) => i.id == outletId);
          if (!outlet) {
            this.SetOutlet(filtered[0]);
          }
        }
      } else {
        return null;
      }

      return outlet;
    },
    activeList() {
      return this.filteredOutlets.findIndex(el => el.id === this.selectedOutlet?.id) ?? undefined;
    },
    showSearchOutlet() {
      return this.outlets && this.outlets.length > 0;  // Standardized: Always show search when outlets exist
    }
  },
  methods: {
    ...mapMutations("app", ["setSelectedOutlet", "setOpenToolbarMenu"]),
    ...mapActions("app", ["getMyWorkingDay", "setPageLoading"]),
    onMenuToggle(isOpen) {
      this.focusSearchOnMenuOpen(isOpen, this.showSearchOutlet, "outletSearchField");

      // Update store when this menu opens/closes
      if (isOpen) {
        this.setOpenToolbarMenu("outlets");
      } else if (this.openToolbarMenu === "outlets") {
        this.setOpenToolbarMenu(null);
      }
    },
    SetOutlet(outlet) {
      this.setPageLoading(true);
      const query = this.$route.query;
      if (Number(query.outletId) !== Number(outlet.id)) {
        query.outletId = outlet.id + "";
        const location = "/dashboard?"+qs.stringify(query);
        window.location = location;
      }
    }
  },
  watch: {
    selectedOutlet(n,p) {
      const outletId = Number(this.$route.query.outletId);
      if (n === null) {
        return;
      }
      if (!outletId && n && n.id) {
        this.SetOutlet(n);
      } else if (n && n.id) {
        this.setSelectedOutlet(n);
        const hotelId = Number(this.$route.query.hotelId);
        this.getMyWorkingDay({ hotelId, outletId: n.id });
      }
    },
    openToolbarMenu(newMenu) {
      // Close this menu if another menu opens
      if (newMenu && newMenu !== "outlets") {
        this.menuOpen = false;
      }
    }
  }
};
</script>
